import { render, staticRenderFns } from "./ProfessionalItemResources.vue?vue&type=template&id=0c5b0408"
import script from "./ProfessionalItemResources.vue?vue&type=script&lang=js"
export * from "./ProfessionalItemResources.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalItemResources.vue?vue&type=style&index=0&id=0c5b0408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports